var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.71663 9.9917H2.29163C1.94996 9.9917 1.66663 10.275 1.66663 10.6167V15.5667C1.66663 15.9084 1.94996 16.1917 2.29163 16.1917H5.71663C6.05829 16.1917 6.34163 15.9084 6.34163 15.5667V10.6167C6.34163 10.275 6.06663 9.9917 5.71663 9.9917Z",
    fill: "#CED4DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7167 6.90005H8.375C8.03333 6.90005 7.75 7.18339 7.75 7.52505V15.5667C7.75 15.9084 8.03333 16.1917 8.375 16.1917H11.7167C12.0583 16.1917 12.3417 15.9084 12.3417 15.5667V7.52505C12.3417 7.18339 12.0583 6.90005 11.7167 6.90005Z",
    fill: "#CED4DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7083 3.80844H14.2833C13.9417 3.80844 13.6583 4.09177 13.6583 4.43344V15.5668C13.6583 15.9084 13.9417 16.1918 14.2833 16.1918H17.7083C18.05 16.1918 18.3333 15.9084 18.3333 15.5668V4.43344C18.3333 4.09177 18.05 3.80844 17.7083 3.80844Z",
    fill: "#CED4DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/chartIcon.3a0b5b3276709ccc163c0f373ec2e742.svg";
export { ForwardRef as ReactComponent };